import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { PencilLine, Eye } from 'lucide-react';
import { TOKENS } from '../state/colors';
import { EstadoBolsa } from '../state/bolsaMachine';

interface EditButtonProps {
  estadoCodigo: EstadoBolsa;
  bolsaId: string;
  onVerDetalle: (bolsaId: string) => void;
}

const TOOLTIP_EDITAR = 'Editar cotización';
const TOOLTIP_VER_DETALLE = 'Ver detalle';

// SPEC-114 (RN-001, RN-002, RN-003) — generaliza el botón de acciones de QuoteTable:
// navega directo al detalle en cualquier estado. El destino solo es editable en
// Borrador (RN-005) — el icono/tooltip reflejan eso, pero ya no bloquean la navegación.
export const EditButton: React.FC<EditButtonProps> = ({ estadoCodigo, bolsaId, onVerDetalle }) => {
  const esBorrador = estadoCodigo === EstadoBolsa.BORRADOR;

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onVerDetalle(bolsaId);
  };

  return (
    <Tooltip title={esBorrador ? TOOLTIP_EDITAR : TOOLTIP_VER_DETALLE} arrow>
      <Box
        component="button"
        type="button"
        data-testid="edit-button"
        aria-label={esBorrador ? TOOLTIP_EDITAR : TOOLTIP_VER_DETALLE}
        onClick={handleClick}
        sx={{
          width: 34,
          height: 34,
          borderRadius: '50%',
          border: 'none',
          backgroundColor: 'transparent',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: TOKENS.muted,
          transition: 'all .15s ease',
          '&:hover': { backgroundColor: 'rgba(147,64,143,.10)', color: TOKENS.purple, transform: 'scale(1.08)' },
        }}
      >
        {esBorrador ? <PencilLine size={15} strokeWidth={2} /> : <Eye size={15} strokeWidth={2} />}
      </Box>
    </Tooltip>
  );
};
